var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { ELSCommonUIConstants, ELSLoggingService, ELSTokenHelper } from '@els/els-ui-common-react';
import { AppConstant, FeatureFlagGroupNames, FeatureFlagNames, USER_ROLE } from 'constants/app.constant';
import { SystemType } from 'models';
import { matchPath } from 'react-router';
import { createAction, handleActions } from 'redux-actions';
import { appActions } from 'redux/ducks/app';
import { courseActions } from 'reports/cw/redux/ducks/courses';
import { fetchCourseSectionInfo } from 'reports/cw/services/courses.service';
import { DEFAULT_PROGRAM_ID, EVOLVE_EDUCATION_SITE, EXAM_CUSTOM_TYPE, HAD_PATHS } from 'reports/had/constants/had.constant';
import { buildCategoryGroupOptions, getDefaultCategoryGroupId } from 'reports/had/services/category.service';
import { fetchCategoryGroupList, fetchCategoryGroupListDwh, fetchCohortsByProgramIds as fetchCohortsByProgramIdsService, fetchDemoStudentDetailByProgram, fetchDemoStudentDetailByProgramV2, fetchLegacyStudentDetailByProgram, fetchPrograms as fetchProgramsService, fetchStudentDetailByEvolveUsername, fetchStudentDetailByEvolveUsernameV2, fetchStudentDetailByProgram, fetchStudentDetailByProgramV2 } from 'reports/had/services/had.service';
import { createSelector } from 'reselect';
import Immutable from 'seamless-immutable';
import { trackAAEvent } from 'services/adobe-analytics.service';
import { fetchFeatureFlags, isFeatureEnabled } from 'services/feature-flag.service';
import { fetchCrosswalkUser } from 'services/user-management.service';
var initialState = Immutable({
    programs: [],
    programId: 0,
    programName: '',
    cohorts: [],
    selectedCohort: {},
    cohortExams: [],
    cohortStudents: [],
    examStudents: [],
    categoryGroupList: [],
    categoryGroupOptions: [],
    categoryGroupSelectedKey: '',
    isTrendLineGraphHidden: false,
    isSubCategoryChangedBySelectingDropdown: false,
    demoEvolveUsername: '',
    isProgramsFetching: false,
    isCohortsFetching: false,
    isCategoryGroupListFetching: false,
    isStudentMultipleCohortEnabled: false,
    isStudentMultipleCohortShow: false,
    selectCourseNGNData: {},
    studentDetail: {},
    isHADStudentFetching: true,
    studentDetailOriginPath: '',
    isInsViewStuPage: false,
    isInsViewStuPageByDefault: false,
    isNgnItemFetching: false,
    featureFlags: [],
    isNavigateFromPS: false,
    hadCustomizationScore: null
});
var restoreState = createAction('HAD/RESTORE');
var setPrograms = createAction('HAD/SET_PROGRAMS');
var setProgramId = createAction('HAD/SET_PROGRAM_ID');
var setProgramName = createAction('HAD/SET_PROGRAM_NAME');
var setCohorts = createAction('HAD/SET_COHORTS');
var setCohortExams = createAction('HAD/SET_COHORT_EXAMS');
var setCohortStudents = createAction('HAD/SET_COHORT_STUDENTS');
var setExamStudents = createAction('HAD/SET_EXAM_STUDENTS');
var setSelectedCohort = createAction('HAD/SET_SELECTED_COHORT');
var setCategoryGroupList = createAction('HAD/SET_CATEGORY_GROUP_LIST');
var setCategoryGroupOptions = createAction('HAD/SET_CATEGORY_GROUP_OPTIONS');
var setCategoryGroupSelectedKey = createAction('HAD/SET_CATEGORY_GROUP_SELECTED_KEY');
var setIsTrendLineGraphHidden = createAction('HAD/SET_IS_TREND_LINE_GRAPH_HIDDEN');
var setIsSubCategoryChangedBySelectingDropdown = createAction('HAD/SET_IS_SUB_CATEGORY_CHANGED_BY_SELECTING_DROPDOWN');
var setDemoEvolveUsername = createAction('HAD/SET_DEMO_EVOLVE_USERNAME');
var setIsProgramsFetching = createAction('HAD/SET_IS_PROGRAMS_FETCHING');
var setIsCohortsFetching = createAction('HAD/SET_IS_COHORTS_FETCHING');
var setIsCategoryGroupFetching = createAction('HAD/SET_IS_CATEGORY_GROUP_FETCHING');
var setIsHADStudentFetching = createAction('HAD/SET_IS_HAD_STUDENT_FETCHING');
var setIsStudentMultipleCohortEnabled = createAction('HAD/SET_IS_STUDENT_MULTIPLE_COHORT_ENABLED');
var setIsStudentMultipleCohortShow = createAction('HAD/SET_IS_STUDENT_MULTIPLE_COHORT_SHOW');
var setSelectCourseNGNData = createAction('HAD/SET_SELECT_COURSE_NGN_DATA');
var setStudentDetail = createAction('HAD/SET_STUDENT_DETAIL');
var setStudentDetailOriginPath = createAction('HAD/SET_STUDENT_DETAIL_ORIGIN_PATH');
var setIsInsViewStuPage = createAction('HAD/SET_IS_INS_VIEW_STU_PAGE');
var setIsInsViewStuPageByDefault = createAction('HAD/SET_IS_INS_VIEW_STU_PAGE_BY_DEFAULT');
var setIsNGNItemFetching = createAction('HAD/SET_IS_NGN_ITEM_FETCHING');
var setIsNavigateFromPS = createAction('HAD/SET_IS_NAVIGATE_FROM_PS');
var setHadCustomizationScore = createAction('HAD/SET_HAD_CUSTOMIZATION_SCORE');
var resetCohortStoredData = function () { return function (dispatch) {
    dispatch(setSelectedCohort({}));
    dispatch(setCohortExams([]));
    dispatch(setCohortStudents([]));
}; };
var fetchCohorts = function (programId, evolveUsername) { return function (dispatch) {
    dispatch(setIsCohortsFetching(true));
    fetchCohortsByProgramIdsService([programId], evolveUsername)
        .then(function (cohorts) {
        dispatch(setCohorts(cohorts || []));
    })
        .catch(function () {
        dispatch(setCohorts([]));
    })
        .finally(function () {
        dispatch(setIsCohortsFetching(false));
    });
}; };
var getSelectedProgramId = function (programs, getState) {
    var hadState = getState()[AppConstant.reduxResources.HAD_STATE];
    if (hadState.programId && programs.find(function (program) { return program.programId === hadState.programId; })) {
        return hadState.programId;
    }
    return programs.length ? programs[0].programId : DEFAULT_PROGRAM_ID;
};
var getSelectedProgramName = function (programs, getState) {
    var hadState = getState()[AppConstant.reduxResources.HAD_STATE];
    if (hadState.programId && programs.find(function (program) { return program.programId === hadState.programId; })) {
        return hadState.programName;
    }
    return programs.length ? programs[0].programName : '';
};
var updateAnalyticsAccountInfo = function (programId, programName) { return function (dispatch, getState) {
    var appState = getState()[AppConstant.reduxResources.APP_STATE];
    var evolveUser = appState.evolveUser;
    var prefix = (evolveUser === null || evolveUser === void 0 ? void 0 : evolveUser.evolveUserId) ? "evo" : "eols";
    trackAAEvent(ELSCommonUIConstants.analytics.eventTypes.contentView, {
        userId: "".concat(prefix, ":").concat((evolveUser === null || evolveUser === void 0 ? void 0 : evolveUser.eolsId) || (evolveUser === null || evolveUser === void 0 ? void 0 : evolveUser.evolveUserId)),
        accountId: "".concat(prefix, ":").concat(programId),
        accountName: "".concat(prefix, ":").concat(programName)
    });
}; };
var redirectToEvolveEducationSite = function () {
    window.location.href = EVOLVE_EDUCATION_SITE;
};
var fetchProgramsHandler = function (dispatch_1, getState_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([dispatch_1, getState_1], args_1, true), void 0, function (dispatch, getState, isPNProgramHidden) {
        var _a, _b, evolveUsername, _c, evolveUser, _d, featureFlags, _e, hadPrograms, _f, instructorId, programs, _g, data, e_1, programId, programName, cohortsPayload, _h, isCWHADPRDLinkEnabled;
        if (isPNProgramHidden === void 0) { isPNProgramHidden = false; }
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    _a = getState()[AppConstant.reduxResources.APP_STATE], _b = _a.evolveUsername, evolveUsername = _b === void 0 ? null : _b, _c = _a.evolveUser, evolveUser = _c === void 0 ? { username: null } : _c, _d = _a.featureFlags, featureFlags = _d === void 0 ? [] : _d;
                    _e = getState()[AppConstant.reduxResources.HAD_STATE].programs, hadPrograms = _e === void 0 ? [] : _e;
                    _f = getState()[AppConstant.reduxResources.SH_STATE].instructorId, instructorId = _f === void 0 ? null : _f;
                    programs = hadPrograms;
                    if (!!programs.length) return [3 /*break*/, 4];
                    _j.label = 1;
                case 1:
                    _j.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchProgramsService(evolveUsername)];
                case 2:
                    _g = (_j.sent()).data, data = _g === void 0 ? [] : _g;
                    programs = data;
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _j.sent();
                    redirectToEvolveEducationSite();
                    return [3 /*break*/, 4];
                case 4:
                    if (isPNProgramHidden) {
                        programs = programs.filter(function (program) { return !program.programTypeName.includes('PN'); });
                    }
                    if (!programs.length) {
                        redirectToEvolveEducationSite();
                    }
                    programId = getSelectedProgramId(programs, getState);
                    programName = getSelectedProgramName(programs, getState);
                    dispatch(setPrograms({ data: programs }));
                    dispatch(setProgramId(programId));
                    dispatch(setProgramName(programName));
                    dispatch(setIsProgramsFetching(false));
                    if (!programId) return [3 /*break*/, 10];
                    _j.label = 5;
                case 5:
                    _j.trys.push([5, 7, 8, 9]);
                    return [4 /*yield*/, fetchCohortsByProgramIdsService([programId], evolveUsername)];
                case 6:
                    cohortsPayload = _j.sent();
                    dispatch(setCohorts(cohortsPayload || []));
                    return [3 /*break*/, 9];
                case 7:
                    _h = _j.sent();
                    dispatch(setCohorts([]));
                    return [3 /*break*/, 9];
                case 8:
                    dispatch(setIsCohortsFetching(false));
                    dispatch(updateAnalyticsAccountInfo(programId, programName));
                    return [7 /*endfinally*/];
                case 9: return [3 /*break*/, 11];
                case 10:
                    dispatch(setIsCohortsFetching(false));
                    _j.label = 11;
                case 11:
                    if (!instructorId) {
                        isCWHADPRDLinkEnabled = isFeatureEnabled(featureFlags, FeatureFlagNames.CW_HAD_PRD_LINK_ENABLED);
                        if (isCWHADPRDLinkEnabled) {
                            dispatch(appActions.fetchSHInstructorId(evolveUser === null || evolveUser === void 0 ? void 0 : evolveUser.userName));
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
};
var fetchHESIDashboardData = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var data, appState, loggedInUser, evolveUser, evolveUserLoading, evolveUserHasBeenCalled, featureFlags, isPNProgramHidden, userId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(setIsProgramsFetching(true));
                dispatch(setIsCohortsFetching(true));
                return [4 /*yield*/, fetchFeatureFlags()];
            case 1:
                data = (_a.sent()).data;
                appState = getState()[AppConstant.reduxResources.APP_STATE];
                appState = __assign(__assign({}, appState), { featureFlags: data });
                loggedInUser = appState.loggedInUser, evolveUser = appState.evolveUser, evolveUserLoading = appState.evolveUserLoading, evolveUserHasBeenCalled = appState.evolveUserHasBeenCalled, featureFlags = appState.featureFlags;
                isPNProgramHidden = isFeatureEnabled(featureFlags, FeatureFlagNames.HAD_PN_PROGRAM_HIDDEN, FeatureFlagGroupNames.HAD_PN_PROGRAM_HIDDEN_GROUP);
                userId = loggedInUser ? loggedInUser.userId || loggedInUser.id : undefined;
                if (userId !== (evolveUser === null || evolveUser === void 0 ? void 0 : evolveUser.eolsId) && !evolveUserLoading && !evolveUserHasBeenCalled) {
                    // We have to fetch evolveUser because in HESI-NG app, the token does not have userName field
                    appActions.fetchEvolveUser(userId);
                }
                return [4 /*yield*/, fetchProgramsHandler(dispatch, getState, isPNProgramHidden)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); }; };
export var fetchCategoryGroupListData = function (cohortId, isStudentRole) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, featureFlags, isCategoryGroupDwhEnable, categoryGroupResponse, _b, categoryGroupOptions, hadState, err_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 5, 6, 7]);
                _a = getState()[AppConstant.reduxResources.APP_STATE].featureFlags, featureFlags = _a === void 0 ? [] : _a;
                isCategoryGroupDwhEnable = isFeatureEnabled(featureFlags, FeatureFlagNames.HAD_CATEGORY_GROUP_DWH_ENABLE);
                dispatch(setIsCategoryGroupFetching(true));
                if (!isCategoryGroupDwhEnable) return [3 /*break*/, 2];
                return [4 /*yield*/, fetchCategoryGroupListDwh(cohortId)];
            case 1:
                _b = _c.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, fetchCategoryGroupList(cohortId)];
            case 3:
                _b = _c.sent();
                _c.label = 4;
            case 4:
                categoryGroupResponse = _b;
                dispatch(setCategoryGroupList(categoryGroupResponse.data || []));
                categoryGroupOptions = buildCategoryGroupOptions(categoryGroupResponse.data || [], isStudentRole);
                dispatch(setCategoryGroupOptions(categoryGroupOptions));
                hadState = getState()[AppConstant.reduxResources.HAD_STATE];
                dispatch(setCategoryGroupSelectedKey((hadState === null || hadState === void 0 ? void 0 : hadState.categoryGroupSelectedKey) || getDefaultCategoryGroupId(categoryGroupOptions, isStudentRole)));
                return [3 /*break*/, 7];
            case 5:
                err_1 = _c.sent();
                dispatch(setCategoryGroupList([]));
                dispatch(setCategoryGroupOptions([]));
                dispatch(setCategoryGroupSelectedKey(''));
                ELSLoggingService.error('had.ts', "Failed to fetch categories group list: ".concat(err_1.message));
                return [3 /*break*/, 7];
            case 6:
                dispatch(setIsCategoryGroupFetching(false));
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}); }; };
var fetchHADStudentData = function (evolveUserNameParam) {
    if (evolveUserNameParam === void 0) { evolveUserNameParam = ''; }
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var appState, data, loggedInUser, selectedCourse, userRole, featureFlags, evolveUser, isHadStudentSummaryNewTableEnable, userId, crosswalkUser, token, hadState, isInsViewStuPageByDefault, categoryGroupOptions, decodeToken, appParams, programId, courseId, courseSectionInfoResponse, studentEvolveUserName, isStudentRole, isInsViewStuPage, evolveUserName, demoEvolveUsername, studentDetailRes, studentDetail, fetchDemoStudentDetailByProgramByFlag, filterStudentExams, isDwhFetchStudentDetailByProgramApiEnabled, isStudentMultiProgram, fetchStudentDetailByEvolveUsernameByFlag, fetchStudentDetailByProgramByFlag, studentDetailApi, cohortId, err_2;
        var _a, _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    dispatch(setIsHADStudentFetching(true));
                    appState = getState()[AppConstant.reduxResources.APP_STATE];
                    if (!!((_a = appState.featureFlags) === null || _a === void 0 ? void 0 : _a.length)) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchFeatureFlags()];
                case 1:
                    data = (_h.sent()).data;
                    appState = __assign(__assign({}, appState), { featureFlags: data });
                    _h.label = 2;
                case 2:
                    loggedInUser = appState.loggedInUser, selectedCourse = appState.selectedCourse, userRole = appState.userRole, featureFlags = appState.featureFlags;
                    _h.label = 3;
                case 3:
                    _h.trys.push([3, 14, 15, 16]);
                    evolveUser = appState.evolveUser;
                    isHadStudentSummaryNewTableEnable = isFeatureEnabled(featureFlags, FeatureFlagNames.HAD_STUDENT_SUMMARY_NEW_TABLE);
                    userId = loggedInUser ? loggedInUser.userId || loggedInUser.id : undefined;
                    if (!(userId !== (evolveUser === null || evolveUser === void 0 ? void 0 : evolveUser.eolsId))) return [3 /*break*/, 5];
                    return [4 /*yield*/, fetchCrosswalkUser(userId, SystemType.EVOLVETYPE)];
                case 4:
                    crosswalkUser = _h.sent();
                    evolveUser = crosswalkUser.data;
                    dispatch(appActions.setEvolveUser(evolveUser));
                    _h.label = 5;
                case 5:
                    token = ELSTokenHelper.getToken();
                    hadState = getState()[AppConstant.reduxResources.HAD_STATE];
                    isInsViewStuPageByDefault = hadState.isInsViewStuPageByDefault, categoryGroupOptions = hadState.categoryGroupOptions;
                    decodeToken = ELSTokenHelper.parseToken(token);
                    appParams = (_b = decodeToken === null || decodeToken === void 0 ? void 0 : decodeToken.user) === null || _b === void 0 ? void 0 : _b.appParams;
                    programId = hadState === null || hadState === void 0 ? void 0 : hadState.programId;
                    if (!programId) {
                        programId = appParams === null || appParams === void 0 ? void 0 : appParams.programCode;
                        dispatch(setProgramId(programId));
                    }
                    if (!!selectedCourse) return [3 /*break*/, 7];
                    courseId = (_d = (_c = decodeToken === null || decodeToken === void 0 ? void 0 : decodeToken.user) === null || _c === void 0 ? void 0 : _c.appParams) === null || _d === void 0 ? void 0 : _d.courseId;
                    dispatch(appActions.setSelectedCourse(courseId));
                    return [4 /*yield*/, fetchCourseSectionInfo(courseId)];
                case 6:
                    courseSectionInfoResponse = _h.sent();
                    dispatch(courseActions.setCourseSectionInfo(courseSectionInfoResponse.data));
                    _h.label = 7;
                case 7:
                    studentEvolveUserName = appParams === null || appParams === void 0 ? void 0 : appParams.studentEvolveUserName;
                    isStudentRole = userRole === USER_ROLE.STUDENT;
                    isInsViewStuPage = !!(userRole === USER_ROLE.EOLS_INSTRUCTOR && studentEvolveUserName);
                    dispatch(setIsInsViewStuPage(isInsViewStuPage));
                    evolveUserName = isInsViewStuPage ? studentEvolveUserName : evolveUser === null || evolveUser === void 0 ? void 0 : evolveUser.userName;
                    demoEvolveUsername = hadState.demoEvolveUsername;
                    studentDetailRes = void 0;
                    studentDetail = void 0;
                    if (!demoEvolveUsername) return [3 /*break*/, 9];
                    fetchDemoStudentDetailByProgramByFlag = isHadStudentSummaryNewTableEnable ? fetchDemoStudentDetailByProgramV2 : fetchDemoStudentDetailByProgram;
                    return [4 /*yield*/, fetchDemoStudentDetailByProgramByFlag(demoEvolveUsername, programId)];
                case 8:
                    // work for demo purpose from launch-pad
                    studentDetailRes = _h.sent();
                    studentDetail = studentDetailRes.data;
                    filterStudentExams = studentDetail.studentExams.filter(function (e) { return e.examType !== EXAM_CUSTOM_TYPE; });
                    studentDetail = __assign(__assign({}, studentDetail), { studentExams: filterStudentExams, examCount: filterStudentExams.length });
                    return [3 /*break*/, 13];
                case 9:
                    isDwhFetchStudentDetailByProgramApiEnabled = isFeatureEnabled(featureFlags, FeatureFlagNames.DWH_STUDENT_DETAIL_BY_PROGRAM_API_ENABLED);
                    isStudentMultiProgram = isFeatureEnabled(featureFlags, FeatureFlagNames.HAD_STUDENT_VIEW_MULTI_PROGRAM);
                    fetchStudentDetailByEvolveUsernameByFlag = isHadStudentSummaryNewTableEnable ? fetchStudentDetailByEvolveUsernameV2 : fetchStudentDetailByEvolveUsername;
                    fetchStudentDetailByProgramByFlag = isHadStudentSummaryNewTableEnable ? fetchStudentDetailByProgramV2 : fetchStudentDetailByProgram;
                    studentDetailApi = isDwhFetchStudentDetailByProgramApiEnabled ? fetchStudentDetailByProgramByFlag : fetchLegacyStudentDetailByProgram;
                    if (!(isStudentRole && isStudentMultiProgram)) return [3 /*break*/, 11];
                    return [4 /*yield*/, fetchStudentDetailByEvolveUsernameByFlag(evolveUserName)];
                case 10:
                    studentDetailRes = _h.sent();
                    studentDetail = studentDetailRes.data;
                    return [3 /*break*/, 13];
                case 11: return [4 /*yield*/, studentDetailApi(evolveUserNameParam || evolveUserName, programId)];
                case 12:
                    studentDetailRes = _h.sent();
                    studentDetail = studentDetailRes.data;
                    _h.label = 13;
                case 13:
                    dispatch(setStudentDetail(studentDetail));
                    cohortId = (_g = (_f = (_e = studentDetailRes === null || studentDetailRes === void 0 ? void 0 : studentDetailRes.data) === null || _e === void 0 ? void 0 : _e.cohorts) === null || _f === void 0 ? void 0 : _f.find(function (e) { return !!e; })) === null || _g === void 0 ? void 0 : _g.cohortId;
                    if (cohortId) {
                        dispatch(fetchCategoryGroupListData(cohortId, true));
                        if (isInsViewStuPageByDefault) {
                            dispatch(setCategoryGroupSelectedKey(getDefaultCategoryGroupId(categoryGroupOptions, isInsViewStuPageByDefault)));
                        }
                    }
                    return [3 /*break*/, 16];
                case 14:
                    err_2 = _h.sent();
                    ELSLoggingService.error('had.ts', "Failed to fetch HAD Student Data: ".concat(err_2.message));
                    return [3 /*break*/, 16];
                case 15:
                    dispatch(setIsHADStudentFetching(false));
                    return [7 /*endfinally*/];
                case 16: return [2 /*return*/];
            }
        });
    }); };
};
var changeIsInstructorViewAsStudent = function (isViewAsStudent) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var routeState, hadSelectors, isInsViewStuPageByDefault, isPathMatch;
    return __generator(this, function (_a) {
        routeState = getState()[AppConstant.reduxResources.ROUTER];
        hadSelectors = getState()[AppConstant.reduxResources.HAD_STATE];
        isInsViewStuPageByDefault = hadSelectors.isInsViewStuPageByDefault;
        if (routeState.location) {
            isPathMatch = matchPath(HAD_PATHS.studentHome, routeState.location.pathname);
            if (!(isPathMatch === null || isPathMatch === void 0 ? void 0 : isPathMatch.isExact) && isInsViewStuPageByDefault) {
                dispatch(setIsInsViewStuPageByDefault(isViewAsStudent));
                dispatch(setCategoryGroupSelectedKey(getDefaultCategoryGroupId(hadSelectors.categoryGroupOptions, false)));
            }
        }
        return [2 /*return*/];
    });
}); }; };
var actions = {
    restoreState: restoreState,
    resetCohortStoredData: resetCohortStoredData,
    getSelectedProgramId: getSelectedProgramId,
    getSelectedProgramName: getSelectedProgramName,
    setPrograms: setPrograms,
    setProgramId: setProgramId,
    setProgramName: setProgramName,
    setCohorts: setCohorts,
    setSelectedCohort: setSelectedCohort,
    setSelectCourseNGNData: setSelectCourseNGNData,
    setStudentDetail: setStudentDetail,
    setStudentDetailOriginPath: setStudentDetailOriginPath,
    setCohortExams: setCohortExams,
    setExamStudents: setExamStudents,
    setCohortStudents: setCohortStudents,
    setCategoryGroupList: setCategoryGroupList,
    setCategoryGroupOptions: setCategoryGroupOptions,
    setCategoryGroupSelectedKey: setCategoryGroupSelectedKey,
    setIsTrendLineGraphHidden: setIsTrendLineGraphHidden,
    setIsSubCategoryChangedBySelectingDropdown: setIsSubCategoryChangedBySelectingDropdown,
    setDemoEvolveUsername: setDemoEvolveUsername,
    setIsProgramsFetching: setIsProgramsFetching,
    setIsCohortsFetching: setIsCohortsFetching,
    setIsCategoryGroupFetching: setIsCategoryGroupFetching,
    setIsHADStudentFetching: setIsHADStudentFetching,
    setIsStudentMultipleCohortEnabled: setIsStudentMultipleCohortEnabled,
    setIsStudentMultipleCohortShow: setIsStudentMultipleCohortShow,
    setIsInsViewStuPage: setIsInsViewStuPage,
    setIsInsViewStuPageByDefault: setIsInsViewStuPageByDefault,
    setIsNGNItemFetching: setIsNGNItemFetching,
    fetchHESIDashboardData: fetchHESIDashboardData,
    fetchCohorts: fetchCohorts,
    fetchCategoryGroupListData: fetchCategoryGroupListData,
    fetchHADStudentData: fetchHADStudentData,
    updateAnalyticsAccountInfo: updateAnalyticsAccountInfo,
    changeIsInstructorViewAsStudent: changeIsInstructorViewAsStudent,
    setIsNavigateFromPS: setIsNavigateFromPS,
    setHadCustomizationScore: setHadCustomizationScore
};
var reducer = handleActions((_a = {},
    _a[actions.restoreState] = function (state, _a) {
        var payload = _a.payload;
        return state.merge(payload);
    },
    _a[actions.setPrograms] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'programs', payload.data);
    },
    _a[actions.setProgramId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'programId', payload);
    },
    _a[actions.setProgramName] = function (state, _a) {
        var payload = _a.payload;
        return state.set('programName', payload);
    },
    _a[actions.setCohorts] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cohorts', payload.data);
    },
    _a[actions.setSelectedCohort] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedCohort', payload);
    },
    _a[actions.setSelectCourseNGNData] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectCourseNGNData', payload);
    },
    _a[actions.setStudentDetail] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentDetail', payload);
    },
    _a[actions.setStudentDetailOriginPath] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentDetailOriginPath', payload);
    },
    _a[actions.setCohortExams] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cohortExams', payload);
    },
    _a[actions.setCohortStudents] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cohortStudents', payload);
    },
    _a[actions.setCategoryGroupList] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'categoryGroupList', payload);
    },
    _a[actions.setCategoryGroupOptions] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'categoryGroupOptions', payload);
    },
    _a[actions.setCategoryGroupSelectedKey] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'categoryGroupSelectedKey', payload);
    },
    _a[actions.setIsTrendLineGraphHidden] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isTrendLineGraphHidden', payload);
    },
    _a[actions.setIsSubCategoryChangedBySelectingDropdown] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isSubCategoryChangedBySelectingDropdown', payload);
    },
    _a[actions.setDemoEvolveUsername] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'demoEvolveUsername', payload);
    },
    _a[actions.setIsProgramsFetching] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isProgramsFetching', payload);
    },
    _a[actions.setIsCohortsFetching] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isCohortsFetching', payload);
    },
    _a[actions.setIsHADStudentFetching] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isHADStudentFetching', payload);
    },
    _a[actions.setIsStudentMultipleCohortEnabled] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isStudentMultipleCohortEnabled', payload);
    },
    _a[actions.setIsStudentMultipleCohortShow] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isStudentMultipleCohortShow', payload);
    },
    _a[actions.setIsCategoryGroupFetching] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isCategoryGroupFetching', payload);
    },
    _a[actions.setIsInsViewStuPage] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isInsViewStuPage', payload);
    },
    _a[actions.setIsInsViewStuPageByDefault] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isInsViewStuPageByDefault', payload);
    },
    _a[actions.setIsNGNItemFetching] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isNgnItemFetching', payload);
    },
    _a[actions.setExamStudents] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'examStudents', payload);
    },
    _a[actions.setIsNavigateFromPS] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isNavigateFromPS', payload);
    },
    _a[actions.setHadCustomizationScore] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'hadCustomizationScore', payload);
    },
    _a), initialState);
var getHadState = function (state) { return state[AppConstant.reduxResources.HAD_STATE]; };
var selectors = {
    getPrograms: createSelector(getHadState, function (state) { return state.programs; }),
    getProgramId: createSelector(getHadState, function (state) { return state.programId; }),
    getProgramName: createSelector(getHadState, function (state) { return state.programName; }),
    getCohorts: createSelector(getHadState, function (state) { return state.cohorts; }),
    getSelectedCohort: createSelector(getHadState, function (state) { return state && state.selectedCohort; }),
    getCohortExams: createSelector(getHadState, function (state) { return state.cohortExams; }),
    getCohortStudents: createSelector(getHadState, function (state) { return state.cohortStudents; }),
    getExamStudents: createSelector(getHadState, function (state) { return state.examStudents; }),
    getCategoryGroupList: createSelector(getHadState, function (state) { return state.categoryGroupList; }),
    getCategoryGroupOptions: createSelector(getHadState, function (state) { return state.categoryGroupOptions; }),
    getCategoryGroupSelectedKey: createSelector(getHadState, function (state) { return state.categoryGroupSelectedKey; }),
    getIsTrendLineGraphHidden: createSelector(getHadState, function (state) { return state.isTrendLineGraphHidden; }),
    getIsSubCategoryChangedBySelectingDropdown: createSelector(getHadState, function (state) { return state.isSubCategoryChangedBySelectingDropdown; }),
    getDemoEvolveUsername: createSelector(getHadState, function (state) { return state.demoEvolveUsername; }),
    getIsProgramsFetching: createSelector(getHadState, function (state) { return state.isProgramsFetching; }),
    getIsCohortsFetching: createSelector(getHadState, function (state) { return state.isCohortsFetching; }),
    getIsCategoryGroupFetching: createSelector(getHadState, function (state) { return state.isCategoryGroupFetching; }),
    getIsHADStudentFetching: createSelector(getHadState, function (state) { return state.isHADStudentFetching; }),
    getIsStudentMultipleCohortEnabled: createSelector(getHadState, function (state) { return state.isStudentMultipleCohortEnabled; }),
    getIsStudentMultipleCohortShow: createSelector(getHadState, function (state) { return state.isStudentMultipleCohortShow; }),
    getSelectCourseNGNData: createSelector(getHadState, function (state) { return state.selectCourseNGNData; }),
    getStudentDetail: createSelector(getHadState, function (state) { return state.studentDetail; }),
    getStudentDetailOriginPath: createSelector(getHadState, function (state) { return state.studentDetailOriginPath; }),
    getIsInsViewStuPage: createSelector(getHadState, function (state) { return state.isInsViewStuPage && !state.isInsViewStuPageByDefault; }),
    getIsInsViewStuPageByDefault: createSelector(getHadState, function (state) { return state.isInsViewStuPageByDefault; }),
    getNGNItemList: createSelector(getHadState, function (state) { return state.ngnItemList; }),
    getIsNGNItemFetching: createSelector(getHadState, function (state) { return state.isNgnItemFetching; }),
    getIsNavigateFromPS: createSelector(getHadState, function (state) { return state.isNavigateFromPS; }),
    getHadCustomizationScore: createSelector(getHadState, function (state) { return state.hadCustomizationScore; })
};
export { actions as hadActions, initialState as hadInitialState, reducer as hadReducer, selectors as hadSelectors };
